import React, { useEffect, useLayoutEffect, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import CommonHeadings from "helper/constant/headings";
import { Button } from "primereact/button";
import { useLocation, useNavigate } from "react-router-dom";
import { collection, getDocs, orderBy, query, where, limit, startAfter, limitToLast, endBefore } from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import TableName from "helper/tableName/tableName";
import { ButtonGroup } from "react-bootstrap";
import Constant from "helper/constant/constant";
import ToastMessages from "helper/toastMessages";
import HeadingComponent from "components/headingComponent";
import ViewDataComponent from "components/viewData";


function BatchStudentVIew() {
  const [studentsData, setStudentsData] = useState([]);
  const [batchInfoView, setBatchInfoView] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  //these are pagination variables
  const [page, setPage] = useState(0);
  const [isNext, setIsNext] = useState(false);

  // MARK: use Effect function
  useEffect(() => {
    fetchStudentsApi();
    setBatchInfoView([
      {
        label: "Batch Name",
        data: location.state.batch_name,
        class: "table__column__capital ms-0"
      },
      {
        label: "Description:",
        data: location.state.description,
        class: "ms-0"
      },
    ]);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //use layout effect function
  useLayoutEffect(() => {
    document.title = CommonHeadings.batchView;
  }, []);

  const batchName = location.state.batch_name;

  // MARK: API
  async function fetchStudentsApi() {
    let q = query(
      collection(dbFirestore, TableName.students), where("status", "==", "active"),
      where("batch_firebase_id", "==", location.state.firebase_id),
      orderBy("created_at", "desc"), limit(Constant.perPage)
    );

    const querySnapshot = await getDocs(q);

    const studentList = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
    }));
    setStudentsData(studentList);
    setLoading(false);
    setPage(0);
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  }

  // MARK: pagination code
  const showNext = ({ item }) => {
    setPage(page + 1);

    const fetchNextData = async () => {
      var paginationQuery;

      paginationQuery = query(
        collection(dbFirestore, TableName.students), where("status", "==", "active"),
        where("batch_firebase_id", "==", location.state.firebase_id),
        orderBy("created_at", "desc"),
        limit(Constant.perPage),
        startAfter(item.created_at)
      );
      const querySnapshot = await getDocs(paginationQuery);

      setStudentsData(
        querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
      );
      setPage(page + 1);
      setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
    };

    if (studentsData.length === 0) {
      alert(ToastMessages.alertMessage);
    } else {
      fetchNextData();
    }
  };

  //  previous data function using pagination previous button
  const fetchPreviousData = async () => {
    setPage(page - 1);

    var paginationQuery;
    paginationQuery = query(
      collection(dbFirestore, TableName.students), where("status", "==", "active"),
      where("batch_firebase_id", "==", location.state.firebase_id),
      orderBy("created_at", "desc"),
      endBefore(studentsData[0].created_at),
      limitToLast(Constant.perPage)
    );
    const querySnapshot = await getDocs(paginationQuery);

    setStudentsData(
      querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
    );
    setPage(page - 1);
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  };

  // condition while selecting the previous button
  const showPrevious = () => {
    if (studentsData.length === 0) {
      fetchStudentsApi();
    } else {
      fetchPreviousData();
    }
  };

  // MARK: UI data
  const studentsColumns = [
    {
      field: "name",
      header: "Name",
      className: "table__column__capital",
    },
    {
      field: "admission_no",
      header: "Admission Number",
    },
    {
      field: "admission_date",
      header: "Admission Date",
    },
  ];

  if (isLoading) {
    return <div className="loading-div"> Loading ... </div>;
  }


  return (
    <div className="modules__main__div">
      <div className="col-12">

        <div className="card modules__card">
          <div style={{ marginBottom: "1.5rem" }}>
            <Button icon="pi pi-arrow-left"
              type="button"
              onClick={() => navigate(-1)}
              className="view__back_button me-3"
            />
          </div>

          <div className="modules__lists_main-content">
            <h5 className="flex-grow-1" style={{ textTransform: "capitalize" }}>
              {batchName}/{CommonHeadings.batchView}
            </h5>

          </div>

          <div className="row mb-5 ms-1 me-1">
            <div className="card card-column ">
              {batchInfoView.length > 0 && (
                <HeadingComponent
                  headingName="Batch Info"
                  classname="mb-3 mt-5 text-center"
                />
              )}
              {batchInfoView.length > 0 &&
                batchInfoView.map((data) => (
                  <ViewDataComponent
                    key={data.label}
                    label={data.label}
                    data={data.data}
                    isShown={data.isShown}
                    class={data.class}
                  />
                ))}
            </div>
          </div>
          <div className="card card-column ">
          {studentsData &&
          
              <DataTable
                className="mt-5 mb-3"
                value={studentsData}
                emptyMessage="No data found."
              >
                {studentsColumns.map((col) => (
                  <Column
                    key={col.field}
                    field={col.field}
                    header={col.header}
                    bodyClassName={col.className}
                    body={col.CardBody}
                  />
                ))}
              </DataTable>
       
          }
          <ButtonGroup
            style={{ gap: "1rem", alignSelf: "center" }}
            className="mt-5 mb-5"
          >
            {
              <button
                disabled={page === 0 ? true : false}
                onClick={() => showPrevious()}
                className={
                  page === 0 ? "previous-disabled-button" : "previous-button"
                }
              >
                <span className="pi pi-angle-left">Previous</span>
              </button>
            }

            {
              <button
                disabled={isNext}
                onClick={() =>
                  showNext({
                    item: studentsData[studentsData.length - 1],
                  })
                }
                className={
                  isNext ? "previous-disabled-button" : "previous-button"
                }
              >
                Next<span className="pi pi-angle-right"></span>
              </button>
            }
          </ButtonGroup>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BatchStudentVIew;
